export default "__VITE_ASSET__K68D4S7x__"